import React from 'react';
import { Modal as ModalComponent } from '@tvg/fuse-design';
import IconLocalOffer from '@tvg/fuse-icons/lib/LocalOffer';
import { PromotionVoucher } from 'types/Product';
import InsuranceVoucherPage from './pages/InsuranceVoucherPage';

export interface InsuranceVoucherDialogProps {
  promotionVoucher: PromotionVoucher;
  open: boolean;
  onClose: () => void;
}

function InsuranceVoucherDialog(props: InsuranceVoucherDialogProps) {
  const { promotionVoucher, open, onClose } = props;

  return (
    <ModalComponent
      open={open}
      onClose={onClose}
      headerIcon={<IconLocalOffer />}
      title={promotionVoucher.offerTitle}
      zIndex="20"
      dataTestId="insurance-voucher-dialog"
      srLabelCloseButton="close insurance voucher dialog"
    >
      <InsuranceVoucherPage offerTerms2={promotionVoucher.offerTerms2} offerTerms3={promotionVoucher.offerTerms3} />
    </ModalComponent>
  );
}

export default InsuranceVoucherDialog;
